import { render, staticRenderFns } from "./invoiceDetailView.vue?vue&type=template&id=15233dfd&scoped=true"
import script from "./invoiceDetailView.vue?vue&type=script&lang=js"
export * from "./invoiceDetailView.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetailView.vue?vue&type=style&index=0&id=15233dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15233dfd",
  null
  
)

export default component.exports